import axios from 'axios'
import { BASE_URL } from '../api'

export const uploadFile = async (file: File, path: string): Promise<string> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('usagePath', path)

  const token = localStorage.getItem('access_token')

  try {
    const res = await axios.post(`${BASE_URL}/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return res.data.url
  } catch (error) {
    console.error('Uploading file failed:', error)
    throw error
  }
}

export const deleteFile = async (url: string): Promise<void> => {
  const token = localStorage.getItem('access_token')

  try {
    await axios.delete(`${BASE_URL}/upload`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: { url }
    })
  } catch (error) {
    console.error('Deleting file failed:', error)
    throw error
  }
}
